import axiosInstance from '../utils/AxiosConfig';

export const getLocations = async () => {
  const response = await axiosInstance.get('/location');
  return response.data.data;
};

export const getLocationSchedule = async (locationId) => {
  const response = await axiosInstance.get(`/location_schedule/${locationId}`);
  return response.data.data;
};

export const createLocation = async (locationData) => {
  const response = await axiosInstance.post('/location', locationData);
  return response.data.data;
};

export const updateLocation = async (locationId, locationData) => {
  const response = await axiosInstance.put(`/location/${locationId}`, locationData);
  return response.data.data;
};

export const deleteLocation = async (locationId) => {
  await axiosInstance.delete(`/location/${locationId}`);
};

export const associateUsersToLocation = async (locationId, email) => {
  const response = await axiosInstance.post(`/location/associate`, { 
    user_email: email,
    location_id: locationId
  });
  return response.data;
};

export const disassociateUsersToLocation = async (locationId, email) => {
  const response = await axiosInstance.post(`/location/disassociate`, { 
    user_email: email,
    location_id: locationId
  });
  return response.data;
};

export const getAssignedUsers = async (locationId) => {
  const response = await axiosInstance.get(`/location/${locationId}/users`);
  return response.data.data;
};

export const updateLocationScedule = async (locationId, schedule) => {
  const response = await axiosInstance.post(`/location_schedule/${locationId}`, schedule);
  return response.data.data;
};

export const getTerminals = async (locationId) => {
  try {
    const response = await axiosInstance.get(`/location/${locationId}/terminals`);
    return response.data.data || [];
  } catch (error) {
    console.error("Error fetching terminals:", error);
    return [];
  }
};

export const addTerminal = async (locationId, terminalData) => {
  const response = await axiosInstance.post(`/location/${locationId}/terminals`, terminalData);
  return response.data.data;
};

export const deleteTerminal = async (locationId, terminalCode) => {
  try {
    const response = await axiosInstance.delete(`/location/${locationId}/${terminalCode}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting terminal:", error);
    throw error;
  }
};
